import { Box, Link, Stack, Tooltip } from "@mui/material"
import { capitalizeFirstLetter, EEmailLogType, EEmailLogTypeParam, EEmailProviders, GenericWrapperContext, getDate, Icon, TEmailLog, TNumStr, truncateText, Typography } from "@cakemail-org/ui-components-v2"
import { TIconName } from "@cakemail-org/ui-components-v2/dist/esm/components/icon/types"
import moment from "moment"
import { useContext } from "react"
import { useTranslation } from "react-i18next"

export function EventLog({ log, submittedBy, showMore }: { log: TEmailLog, submittedBy?: string, showMore?: boolean }) {
    const genericWrapper = useContext(GenericWrapperContext)
    const { t, i18n } = useTranslation()

    const { email, type, time, provider: initProvider, sender_email } = log

    let iconName = ""
    let provider: EEmailProviders | string = initProvider

    let user = submittedBy || t("general-recipient")
    let target

    let text = t("email-log-type-" + type)

    if (provider == EEmailProviders.unknown) {
        provider = t("general-unknown-provider")
    }

    switch (type) {
        // === Delivery ===
        case EEmailLogType.submitted:
            break
        case EEmailLogType.queued:
        case EEmailLogType.processing:
            target = t("email-log-for-delivery-txt")
            break
        case EEmailLogType.delivered:
            target = `${t("general-to-txt")} ${provider || sender_email?.split("@")[1]}`
            break

        // === Engagement ===
        case EEmailLogType.click:
            iconName = "Clicks24"
            break
        case EEmailLogType.unsubscribe:
        case EEmailLogType.global_unsubscribe:
        case EEmailLogType.global_unsubscribe_reason:
            iconName = "Unsubscribes24"
            break
        case EEmailLogType.open:
            iconName = "Opens24"
            break
        case EEmailLogType.other:
            iconName = "User24"
            break

        // === Issues ===
        case EEmailLogType.bounce:
            iconName = "Bounce24"
            target = `${t("general-by-txt")} ${provider || sender_email?.split("@")[1]}`
            break
        case EEmailLogType.spam:
            iconName = "Flag24"
            target = user
            break
        case EEmailLogType.error:
            iconName = "Domainblocked24"
            break
        case EEmailLogType.rejected:
            iconName = "Warning24"
            break
    }

    return <Stack direction="row" className={`eventLog ${showMore ? "showMore" : ""}`} alignItems={showMore ? "stretch" : "center"}>
        {!iconName ?
            <Stack ><Box className="circledIcon"><Icon name="Checkmark10" color="white" /></Box> </Stack>
            :
            <Stack ><Box><Icon name={iconName as TIconName} color="body1" /></Box> </Stack>
        }
        <Stack direction="column">
            <Typography variant="body1" className="semiBold">{text} {target}</Typography>
            {log.metadata?.url &&
                <Tooltip title={log.metadata.url}>
                    <Box>
                        <Typography variant="body1S" color="silver.main">
                            {truncateText(log.metadata.url, 40)}
                        </Typography>
                    </Box>

                </Tooltip>
            }
            {log.metadata?.reason &&
                <Typography variant="body1S" color="silver.main">
                    {log.metadata.reason}
                </Typography>
            }

            {log.metadata?.bounce_type &&
                <Typography variant="body1S" color="silver.main">
                    {log.metadata.bounce_type}
                </Typography>
            }
            {log.metadata?.error_message &&
                <Typography variant="body1S" color="silver.main">
                    {log.metadata.error_message}
                </Typography>
            }
            <Typography variant="body1S" color="silver.main">
                {getDate({
                    date: time,
                    format: "LTS L"
                })}
            </Typography>

            {showMore && log.metadata &&
                Object.entries(log.metadata).map(([name, value]: [name: string, value: any], index) => {
                    let formatedValue = <div key={`log-extra-meta-${index}`}></div>
                    if (!["error_message", "bounce_type", "reason", "url"].includes(name)) {
                        let content: any = ""
                        switch (name) {
                            case "user_agent":
                                content = <>
                                    <b>{/*t(`email-log-meta-${name}`)*/ name}</b> : {`${t("general-is-bot")} : ${value.is_bot}, ${value.device.brand}, ${value.os.family}, ${value.browser.family}`}
                                </>
                                break
                            default:
                                content = <>
                                    <b>{/*t(`email-log-meta-${name}`)*/ name}</b> : {typeof value === "object" ? JSON.stringify(value) : value}
                                </>
                                break
                        }

                        formatedValue = <Typography key={`log-extra-meta-${index}`} variant="body1S" color="silver.main">
                            {content}
                        </Typography>
                    }
                    return formatedValue
                })
            }

        </Stack>

    </Stack>
}